import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-color-swatch',
    templateUrl: './color-swatch.component.html',
    styleUrls: ['./color-swatch.component.less'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
})
export class ColorSwatchComponent {
    color     = input<string>('');
    showLabel = input<boolean>(true);
}
